import { createIcon } from '../shared'

const HeartIcon = createIcon(
  ({ color }) => (
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7331 5.09108C15.4951 4.81508 14.0251 5.13808 12.7111 6.47108C12.618 6.56541 12.5072 6.64032 12.3849 6.69144C12.2627 6.74257 12.1315 6.7689 11.9991 6.7689C11.8666 6.7689 11.7354 6.74257 11.6132 6.69144C11.4909 6.64032 11.3801 6.56541 11.2871 6.47108C9.97305 5.13708 8.50305 4.81408 7.26505 5.09008C6.00205 5.37208 4.88605 6.29608 4.34505 7.64608C3.32905 10.1801 4.25105 14.8401 11.9991 19.3481C19.7461 14.8401 20.6691 10.1801 19.6531 7.64808C19.1121 6.29708 17.9961 5.37308 16.7331 5.09108ZM21.5101 6.90308C23.1141 10.9031 21.0161 16.5931 12.4881 21.3731C12.3387 21.4568 12.1703 21.5008 11.9991 21.5008C11.8278 21.5008 11.6594 21.4568 11.5101 21.3731C2.98205 16.5921 0.884049 10.9021 2.48905 6.90208C3.26805 4.96008 4.90305 3.56808 6.83105 3.13808C8.52805 2.76008 10.3831 3.14108 12.0001 4.42408C13.6171 3.14108 15.4721 2.76008 17.1701 3.13808C19.0971 3.56808 20.7321 4.96108 21.5101 6.90308Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'HeartIcon',
)

export { HeartIcon }
